import {
  directionOutcomes,
  offers,
  siteCopy,
  substackOffer,
  type DirectionOffer,
} from "../../content";
import type { Direction } from "../../lib/scoring";

import "./boards.css";

const copy = siteCopy.boards;

export interface BoardsPanelProps {
  suggestedDirection?: Direction;
  onClose?: () => void;
  onSelect?: (offer: DirectionOffer) => void;
  embedded?: boolean;
}

const directionOffers = offers.filter(
  (offer): offer is DirectionOffer => offer.direction !== null,
);

export function BoardsPanel({
  suggestedDirection,
  onClose,
  onSelect,
  embedded = false,
}: BoardsPanelProps) {
  const PanelTitle = embedded ? "h3" : "h2";
  const OfferTitle = embedded ? "h4" : "h3";

  return (
    <section
      className="boards-panel"
      data-embedded={embedded || undefined}
      aria-labelledby="boards-title"
    >
      <header className="boards-panel__header">
        <div>
          <p className="boards-panel__eyebrow">{copy.eyebrow}</p>
          <PanelTitle className="boards-panel__title" id="boards-title">
            {copy.title}
          </PanelTitle>
        </div>
        {onClose && !embedded ? (
          <button className="boards-panel__quiet-button" type="button" onClick={onClose}>
            Sluiten
          </button>
        ) : null}
      </header>

      <p className="boards-panel__intro">{copy.intro}</p>

      <div className="boards-panel__grid">
        {directionOffers.map((offer, index) => {
          const direction = offer.direction;
          const outcome = directionOutcomes[direction];
          const suggested = direction === suggestedDirection;
          return (
            <article
              className="boards-panel__board"
              data-direction={direction}
              data-suggested={suggested || undefined}
              key={offer.id}
            >
              <div className="boards-panel__board-shape" aria-hidden="true">
                <span>{index + 1}</span>
              </div>
              <div className="boards-panel__board-copy">
                {suggested ? (
                  <p className="boards-panel__match">{copy.matchLabel}</p>
                ) : null}
                <OfferTitle>{offer.label}</OfferTitle>
                <p className="boards-panel__route">{outcome.headline}</p>
                <p>{offer.description}</p>
                {offer.price ? <p className="boards-panel__price">{offer.price}</p> : null}
                <a
                  className="boards-panel__link"
                  href={offer.href}
                  onClick={() => onSelect?.(offer)}
                  rel="noreferrer"
                  target="_blank"
                >
                  {offer.ctaLabel}
                  <span aria-hidden="true">↗</span>
                </a>
              </div>
            </article>
          );
        })}
      </div>

      <aside className="boards-panel__shore" aria-labelledby="boards-shore-title">
        <div>
          <p className="boards-panel__eyebrow">{copy.shoreEyebrow}</p>
          <OfferTitle id="boards-shore-title">{copy.shoreTitle}</OfferTitle>
          <p>{substackOffer.description}</p>
        </div>
        <a
          className="boards-panel__substack-link"
          href={substackOffer.href}
          target="_blank"
          rel="noreferrer"
        >
          {substackOffer.ctaLabel}
          <span aria-hidden="true">↗</span>
        </a>
      </aside>
    </section>
  );
}
